<template>
    <el-dialog class="rma-dialog"
               width="950px"
               :visible.sync="showDialog"
               append-to-body
               @open="loadRma"
               @close="closeDialog"
               :close-on-click-modal="false">
        <div v-loading="loading">
            <div v-if="rmaForm.claimNumber" id="rmaForm" style="display: flex; flex-direction: column">
                <div style="display:flex; justify-content: space-between;">
                    <span><strong>{{$t('common.rmaNum')}}</strong>{{ rmaForm.rmaNumber }}</span>
                    <span><strong>{{$t('common.rmaDate')}}</strong> {{ rmaForm.rmaDate }}</span>
                </div>
                <hr style="width: 100%;" />
                <div style="display: flex; flex-direction: row; align-items: center; height: 30px; margin-bottom: 15px; justify-content: space-between; flex-wrap: wrap;">
                    <label style="width: 20%; font-weight: 600;">Status:</label>
                    <div style="width: 80%;">
                        <rma-status-selector disabled v-model="rmaForm.status"></rma-status-selector>
                    </div>
                </div>
                <hr style="width: 100%;" />
                <div style="display: flex; flex-direction: column;">
                    <h3>{{$t('rma.returnTo')}}</h3>
                    <div style="display: flex; flex-direction: column; margin-bottom: 10px;">
                        <span>{{$t('common.hardtEquipmentManufacturing')}}</span>
                        <span>{{$t('common.fifthAvenue')}}</span>
                        <span>{{$t('common.montrealQuebec')}}</span>
                        <span>{{$t('common.canadaH8T2V3')}}</span>
                        <p>
                            <attn-selector disabled :attns="rmaForm.attns" v-model="rmaForm.attn"></attn-selector>
                        </p>
                    </div>
                    <div style="display: flex; align-items: center; margin-bottom: 10px;">
                        <label style="width: 35%;">{{$t('common.reasonForReturn')}}</label>
                        <el-select v-model="rmaForm.reason" style="width: 100%;" :placeholder="$t('common.pleseSelectReasonForReturn')">
                            <el-option :label="$t('common.returnRequestFromRDLabManager')" value="Return Request from R&D Lab Manager"></el-option>
                            <el-option :label="$t('common.returnRequestFromProductManager')" value="Return Request from Product Manager"></el-option>
                            <el-option :label="$t('common.returnRequestFromProjectLeader')" value="Return Request from Project Leader"></el-option>
                        </el-select>
                    </div>
                </div>
                <hr style="width: 100%;" />
                <div style="display: flex; flex-direction: column;">
                    <h3>{{$t('common.customerSiteInfo')}}</h3>
                    <span for="rmaForm.selectedCustomer.name">{{ rmaForm.selectedCustomer.name }}</span>
                    <span for="rmaForm.selectedCustomer.phone">{{ rmaForm.selectedCustomer.phone }}</span>
                </div>
                <hr style="width: 100%;" />
                <div style="display: flex; flex-direction: column;">
                    <h3>{{$t('common.serviceCoInfo')}}</h3>
                    <span>{{ rmaForm.serviceCompany.name }}</span>
                    <span>{{ rmaForm.serviceCompany.code }}</span>
                    <span>{{ rmaForm.serviceCompany.street }}</span>
                    <span>{{ rmaForm.serviceCompany.city }}, {{ rmaForm.serviceCompany.zip }}</span>
                    <span>{{ rmaForm.serviceCompany.phone }}</span>
                    <span>{{ rmaForm.serviceCompany.contactPersonName }}</span>
                </div>
                <hr style="width: 100%;" />
                <div style="display: flex; flex-direction: column;">
                    <h3>{{$t('common.equipmentInformation')}}</h3>
                    <div style="display: flex; flex-direction: row; align-items: center; height: 30px; margin-bottom: 15px; justify-content: space-between;">
                        <label style="width: 20%; font-weight: 600;">{{$t('common.modelColon')}}</label>
                        <div style="width: 80%;">
                            <product-selector disabled v-model="rmaForm.productId"></product-selector>
                        </div>
                    </div>
                    <div style="display: flex; flex-direction: row; align-items: center; height: 30px; margin-bottom: 15px; justify-content: space-between;">
                        <label style="width: 20%; font-weight: 600;">{{$t('common.serialNumColon')}}</label>
                        <div style="width: 80%;">
                            <span>{{ rmaForm.serialNumber }}</span>
                        </div>
                    </div>
                    <div style="display: flex; flex-direction: row; align-items: center; height: 30px; margin-bottom: 15px; justify-content: space-between;">
                        <label style="width: 20%; font-weight: 600;">{{$t('common.serviceCoverageColon')}}</label>
                        <div style="width: 80%;">
                            <service-coverage-selector disabled v-model="rmaForm.serviceCoverage"></service-coverage-selector>
                        </div>
                    </div>
                    <div style="display: flex; flex-direction: row; align-items: center; height: 30px; margin-bottom: 15px; justify-content: space-between;">
                        <label style="width: 20%; font-weight: 600;">{{$t('common.reportSymptomColon')}}</label>
                        <div style="width: 80%;">
                            <span>{{ rmaForm.complaint }}</span>
                        </div>
                    </div>
                </div>
                <hr style="width: 100%;" />
                <div style="display: flex; flex-direction: column;">
                    <div style="display: flex;">
                        <label style="width: 25%; font-weight: 600;">
                            {{$t('common.returnAuthorizationNum')}}
                        </label>
                        <div style="width: 75%;">
                            <span>{{ rmaForm.serviceTicket.authNumber }}</span>
                        </div>
                    </div>
                    <div style="display: flex;">
                        <label style="width: 25%; font-weight: 600;">{{$t('common.authNumDateAndTimeColon')}}</label>
                        <div style="width: 75%;">
                            <span>{{ rmaForm.serviceTicket.raisedOn }}</span>
                        </div>
                    </div>
                    <div style="display: flex;">
                        <label style="width: 20%; font-weight: 600;">TSR:</label>
                        <span style="width: 80%;">{{ rmaForm.serviceTicket.tsr }}</span>
                    </div>
                </div>
                <hr style="width: 100%;" />
                <div style="display: flex; flex-direction: column; margin-top: 20px;">
                    <div style="display: flex; align-items: center; margin-bottom: 10px;">
                        <label style="width: 35%;">{{$t('common.hardtServiceTicketNum')}}</label>
                        <div style="width: 65%;">
                            <el-input disabled v-model="rmaForm.serviceTicketNumber"></el-input>
                        </div>
                    </div>
                    <div style="display: flex;">
                        <label style="width: 35%;">{{$t('common.hardtClaimNum')}}</label>
                        <div style="width: 65%;">
                            <span>{{ rmaForm.claimNumber }}</span>
                        </div>
                    </div>
                    <div style="display: flex; align-items: center; margin-top: 10px;">
                        <label style="width: 35%;">{{$t('common.hardtInvoicePartPurchaseNum')}}</label>
                        <div style="width: 65%;">
                            <el-input disabled v-model="rmaForm.invoiceNumber"></el-input>
                        </div>
                    </div>
                </div>
                <hr style="width: 100%;" />
                <div style="display: flex; flex-direction: column;">
                    <h3>{{$t('common.shippingMethodColon')}}</h3>
                    <span>{{ rmaForm.shippingMethod }}</span>
                    <div style="display: flex; align-items: center; margin-top: 10px;">
                        <label style="width: 35%;">{{$t('common.trackingNum')}}</label>
                        <div style="width: 65%;">
                            <el-input disabled v-model="rmaForm.trackingNumber"></el-input>
                        </div>
                    </div>
                    <div v-if="isTrackInfoLoaded" style="display: flex; flex-direction: column; margin: 10px 0;">
                        <div style="display: flex; flex-direction: row; min-height: 40px;">
                            <div style="width: 50%; display: flex; flex-direction: column;">
                                <label style="font-weight: 600;">{{$t('common.serviceColon')}}</label>
                                <span>{{ trackForm.service }}</span>
                            </div>
                            <div style="width: 50%; display: flex; flex-direction: column;">
                                <label style="font-weight: 600;">{{$t('common.weightColon')}}</label>
                                <span>{{ trackForm.weight }}</span>
                            </div>
                        </div>
                        <div style="display: flex; flex-direction: row; min-height: 40px;">
                            <div style="width: 50%; display: flex; flex-direction: column;">
                                <label style="font-weight: 600;">{{$t('common.shippedOnColon')}}</label>
                                <span>{{ trackForm.date }}</span>
                            </div>
                            <div style="width: 50%; display: flex; flex-direction: column;">
                                <label style="font-weight: 600;">{{$t('common.referenceNumbersColon')}}</label>
                                <span style="white-space: pre;">{{ trackForm.referenceNumbers }}</span>
                            </div>
                        </div>
                    </div>
                    <div style="width: 80px; display: flex; flex-direction: row; align-self: flex-end; margin: 10px 0;">
                        <el-button id="trackBtn" :disabled="loading"
                                   type="primary"
                                   @click="getTrackInfo">{{$t('common.track')}}</el-button>
                    </div>
                    <div style="display: flex; align-items: center; margin-bottom: 10px;">
                        <label style="width: 35%;">{{$t('common.comment')}}</label>
                        <div style="width: 65%;">
                            <el-input v-model="rmaForm.comment"></el-input>
                        </div>
                    </div>
                    <!--<img src="static/ups_tracking.jpg"
    @click="openTrackingWindow"
    style="cursor: pointer; margin-left: auto; margin-right: auto; display: block;">-->
                </div>
                <hr style="width: 100%;" />
                <div style="display: flex; flex-direction: column;">
                    <el-table :data="rmaForm.parts"
                              size="mini"
                              class="tablewithshading">
                        <el-table-column :label="$t('common.partNum')">
                            <template slot-scope="scope">
                                <el-tooltip effect="dark"
                                            :content="scope.row.part.name"
                                            placement="top">
                                    <el-tag type="info"
                                            size="small"
                                            :disable-transitions="true"
                                            style="margin-right:5px;">{{scope.row.part.partNo}}</el-tag>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="part.name"
                                         :label="$t('common.name')"
                                         width="250"></el-table-column>
                        <el-table-column :label="$t('common.coo')">
                            <template slot-scope="scope">
                                {{scope.row.part.countryOfOrigin}}
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('common.price')">
                            <template slot-scope="scope">
                                {{scope.row.part.price | money}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="part.extendedPrice"
                                         :label="$t('common.extPrice')">
                            <template slot-scope="scope">
                                {{(Number.isInteger(scope.row.quantity) ? (scope.row.part.extendedPrice * scope.row.quantity) : scope.row.part.extendedPrice) | money}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="quantity"
                                         :label="$t('common.quantity')"></el-table-column>
                    </el-table>
                </div>
                <hr style="width: 100%;" />
                <el-button id="printBtn" @click="printRma()"
                           :loading="printing"
                           :disabled="rmaForm.id == 0">
                    <i class="el-icon-printer"></i>
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
    import api from "../api";
    import { AttnSelector, ProductSelector, ServiceCoverageSelector } from "@/app/shared/components";
    import RmaStatusSelector from "@/app/shared/components/RmaStatusSelector.vue";
    export default {
        name: "preview-rma-dialog",
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            rmaId: {
                required: true
            }
        },
        components: {
            ProductSelector,
            AttnSelector,
            ServiceCoverageSelector,
            RmaStatusSelector
        },
        data() {
            return {
                rmaForm: {},
                trackForm: {},
                loading: false,
                printing: false,
                showDialog: this.visible,
                isUserServiceCompany: false,
                isTrackInfoLoaded: false
            };
        },
        watch: {
            visible: function (val) {
                this.showDialog = val;
            }
        },
        methods: {
            loadRma() {
                this.loading = true;
                api.getRma(this.rmaId).then(response => {
                    this.isUserServiceCompany = this.$currentUser.profile.role != "admin";
                    this.rmaForm = response.data;
                    this.loading = false;
                });
            },
            printRma() {
                this.printing = true;
                api.printRma(this.rmaId).then(
                    response => {
                        this.printing = false;
                        var oHiddFrame = document.createElement("iframe");
                        oHiddFrame.style.visibility = "hidden";
                        oHiddFrame.style.position = "fixed";
                        oHiddFrame.style.right = "0";
                        oHiddFrame.style.bottom = "0";
                        oHiddFrame.src = "javascript:void(0)";
                        document.body.appendChild(oHiddFrame);
                        var dstDoc =
                            oHiddFrame.contentDocument || oHiddFrame.contentWindow.document;
                        dstDoc.write(response.data);

                        dstDoc.close();
                        var isFirefox = typeof InstallTrigger !== "undefined";
                        if (isFirefox) {
                            oHiddFrame.contentWindow.print();
                            document.body.removeChild(oHiddFrame);
                        } else {
                            setTimeout(function () {
                                oHiddFrame.contentWindow.print();
                                document.body.removeChild(oHiddFrame);
                            }, 500);
                        }
                    },
                    () => (this.printing = false)
                );
            },
            closeDialog() {
                this.showDialog = false;
                for (var property in this.rmaForm) {
                    if (this.rmaForm.hasOwnProperty(property)) {
                        switch (typeof this.rmaForm[property]) {
                            case "string":
                                this.rmaForm[property] = null;
                                break;
                            case "number":
                                this.rmaForm[property] = null;
                                break;
                            case "object":
                                this.rmaForm[property] = null;
                                break;
                            case "undefined":
                                break;
                        }
                    }
                }

                this.$emit("dialogClosed");
            },
            openTrackingWindow() {
                var url = "http://www.ups.com/WebTracking/track?loc=en_US&WT.svl=PNRO_L1";
                window.open(url);
            },
            getTrackInfo() {
                if (!this.rmaForm.trackingNumber) {
                    return;
                }
                this.loading = true;
                api.
                    getTrackingInfo(this.rmaForm.trackingNumber)
                    .then(response => {
                        this.trackForm = response.data;
                        this.isTrackInfoLoaded = true;
                        this.loading = false;
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        }
    };
</script>

<style scoped>
    h4 {
        margin-bottom: 0;
    }

    p {
        margin: 0;
    }

    .rma-dialog > > > .el-dialog__body {
        padding: 0 20px;
    }

    .totals td:nth-child(2) {
        text-align: right;
        padding: 1px 4px 1px 4px;
    }

    .trips-table th, .trips-table td {
        text-align: left;
    }

    .trips-table th:nth-child(2), .trips-table td:nth-child(2) {
        padding-left: 180px;
    }

    #printBtn {
        width: 60px;
        align-self: end;
    }
</style>


// WEBPACK FOOTER //
// ClientApp/app/rma/components/PreviewRmaDialog.vue